const Content = {
  title: 'Latest News',
  stories: [
    {
      'date': 'Sep 25, 2018',
      'headline': 'A Data Science Framework for Forecasting Opening Box Office Revenues',
      'link': 'https://www.datascience.com/blog/data-science-forecasting-box-office'
    },
    {
      'date': 'Aug 28, 2018',
      'headline': 'MoviePass Poll: Customer Satisfaction Plummets - Exclusive with The Hollywood Reporter',
      'link': 'https://www.hollywoodreporter.com/news/moviepass-poll-customer-satisfaction-plummets-consider-bolting-1137813'
    },
    {
      'date': 'July 18, 2018',
      'headline': 'CEO Jon Penn speaks to VICE Media about "the trailer boom"',
      'link': 'https://news.vice.com/en_us/article/594g5d/this-is-why-you-cant-stop-watching-movie-trailers'
    },
    {
      'date': 'July 18, 2018',
      'headline': 'The New Yorker: How Much Longer Will MoviePass Last?',
      'link': 'https://www.newyorker.com/culture/cultural-comment/how-much-longer-will-moviepass-last'
    },
    {
      'date': 'June 8, 2018',
      'headline': 'National Research Group (NRG) Releases Polling Data On Attitudes Towards Sports Gambling in the Wake of Supreme Court Decision and on the Eve of Game 4 of NBA Finals',
      'link': 'https://www.prnewswire.com/news-releases/national-research-group-nrg-releases-polling-data-on-attitudes-towards-sports-gambling-in-the-wake-of-supreme-court-decision-and-on-the-eve-of-game-4-of-nba-finals-300662457.html'
    },
    {
      'date': 'May 18, 2018',
      'headline': 'Can MoviePass Survive the Summer?',
      'link': 'https://slate.com/culture/2018/05/moviepass-a-movie-subscription-giant-is-struggling.html'
    },
    {
      'date': 'April 23, 2018',
      'headline': 'MoviePass Poll: Subscribers See Far More Films; Many Go Alone and Midweek (Exclusive)',
      'link': 'https://www.hollywoodreporter.com/news/moviepass-poll-subscribers-see-far-more-films-go-alone-midweek-1104829'
    },
    {
      'date': 'August 2, 2017',
      'headline': 'Studios Fight Back Against Withering Rotten Tomatoes Scores',
      'link': 'http://www.hollywoodreporter.com/news/studios-fight-back-withering-rotten-tomatoes-scores-1025575'
    },
    {
      'date': 'July 21, 2017',
      'headline': 'How Rotten Tomatoes became Hollywood\'s most influential and feared - website',
      'link': 'http://www.latimes.com/business/hollywood/la-fi-ct-rotten-tomatoes-20170721-htmlstory.html'
    },
    {
      'date': 'June 26, 2017',
      'headline': 'How Trump Has Changed How We\'re Giving To Charity',
      'link': 'https://www.fastcompany.com/40434556/how-trump-has-changed-how-were-giving-to-charity/'
    },
    {
      'date': 'June 9, 2017',
      'headline': 'How Hollywood Came to Fear and Loathe Rotten Tomatoes',
      'link': 'http://www.vanityfair.com/hollywood/2017/06/how-hollywood-came-to-fear-and-loathe-rotten-tomatoes'
    },
    {
      'date': 'April 14, 2017',
      'headline': 'TV News Poll: Bill O\'Reilly Viewed Most Negatively Among News Figures',
      'link': 'http://www.hollywoodreporter.com/news/tv-news-poll-bill-oreilly-viewed-negatively-news-figures-993684'
    },
    {
      'date': 'February 22, 2017',
      'headline': 'Oscars Poll: 66 Percent of Trump Voters Turn Off Awards Shows When Speeches Get Political',
      'link': 'http://www.hollywoodreporter.com/news/oscars-poll-66-trump-voters-turn-awards-shows-speeches-get-political-978268'
    },
    {
      'date': 'October 5, 2016',
      'headline': 'NRG Names Two Well-Known Researchers To Leadership Team Under New Owner',
      'link': 'http://deadline.com/2016/10/nrg-new-leadership-jason-pritchett-chuck-gaylord-research-industry-shake-up-1201831202/'
    },
    {
      'date': 'September 21, 2016',
      'headline': 'Stagwell Media Invests in Finn Partners',
      'link': 'http://www.prnewswire.com/news-releases/stagwell-media-invests-in-finn-partners-300331796.html'
    },
    {
      'date': 'August 2, 2016',
      'headline': 'Mark Penn\'s Stagwell Group Buys Majority Stake in PMX Agency',
      'link': 'http://adage.com/article/agency-news/mark-penn-s-stagwell-group-buys-majority-stake-pmx-agency/305281/'
    },
    {
      'date': 'January 5, 2016',
      'headline': 'Mark Penn\'s Stagwell Acquires Creative Agency Code and Theory',
      'link': 'http://www.wsj.com/articles/mark-penns-stagwell-acquires-creative-agency-code-and-theory-1452027259'
    },
    {
      'date': 'December 8, 2015',
      'headline': 'Jon Penn Named NRG CEO Following Stagwell Acquisition',
      'link': 'http://deadline.com/2015/12/jon-penn-new-ceo-of-national-research-group-1201661271/'
    }
  ]
};

export { Content };
